<p-floatlabel class="w-full" variant="on">
  <p-select
    (onChange)="selectionChange.emit($event.value)"
    [autofocusFilter]="true"
    [filter]="true"
    [formControl]="this.control()"
    [optionDisabled]="this.optionDisabled()"
    [optionLabel]="this.textField()"
    [optionValue]="this.valueField()"
    [options]="this.items()"
    [scrollHeight]="scrollHeight()"
    [showClear]="!isRequired()"
    [virtualScrollItemSize]="40"
    [virtualScroll]="true"
    appendTo="body"
    fluid
  >
    <ng-template #item let-item>
      @if (itemTemplate()) {
        <ng-container *ngTemplateOutlet="itemTemplate()!; context: { $implicit: item }"/>
      } @else {
        {{ item[textField()] }}
      }
    </ng-template>
    <ng-template #selectedItem let-selectedOption>
      @if (itemTemplate()) {
        <ng-container *ngTemplateOutlet="itemTemplate()!; context: { $implicit: selectedOption }"/>
      } @else {
        {{ selectedOption[textField()] }}
      }
    </ng-template>
  </p-select>
  <label>
    {{ label() }}
    @if (isRequired()) {
      <span class="text-red-500">*</span>
    }
  </label>
</p-floatlabel>
@if (control().invalid && control().touched && control().hasError('required')) {
  <p-message severity="error" size="small" variant="simple">{{ 'error.required' | translate }}</p-message>
}
